import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Fotos</h2>
          <p>
          Um conjunto de fotos vibrantes e apetitosas que capturam a diversidade de nossos doces deliciosos. As imagens incluem doces decorados com perfeição, chocolates cuidadosamente elaborados e outras delícias, refletindo a riqueza de sabores e texturas da nossa confeitaria, onde cada detalhe é feito com muito carinho e amor para você.          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
